import {Injectable, EventEmitter} from '@angular/core';
import {ZerothTab} from './classes/zeroth-tab.model';
import {FirstTab} from './classes/first-tab.model';
import {Proposal} from './classes/second-tab.model';
import {ThirdTab} from './classes/third-tab.model';
import {FourthTab} from './classes/fourth-tab.model';

@Injectable()
export class FormDataService {
  zerothTab: ZerothTab;
  firstTab: FirstTab;
  secondTab: Proposal;
  seller: ThirdTab;
  fourthTab: FourthTab;

  clear() {
    this.setFirstTabData(new FirstTab());
    this.setSecondTab(new Proposal());
    this.setSeller(new ThirdTab());
  }

  setZerothTabData(value: ZerothTab) {
    this.zerothTab = value;
  }

  getZerothTabData() {
    return this.zerothTab;
  }

  setFirstTabData(value: FirstTab) {
    this.firstTab = value;
  }

  getFirstTabData() {
    return this.firstTab;
  }

  setSecondTab(value: Proposal) {
    this.secondTab = value;
  }

  getSecondTab() {
    return this.secondTab;
  }

  setSeller(value: ThirdTab) {
    this.seller = value;
  }

  getSeller() {
    return this.seller;
  }

  setFourthTab(value: FourthTab) {
    this.fourthTab = value;
  }

  getFourthTab() {
    return this.fourthTab;
  }

  getFormData() {
    const isHomeDelivery = this.fourthTab && this.fourthTab.deliveryType === 'homeDelivery';
    const homeDeliveryProps = isHomeDelivery && {
      isHomeDelivery: isHomeDelivery,
      claimDate: this.fourthTab.homeDeliveryAvailableCourierSelectedDate,
      courierExternalId: this.fourthTab.homeDeliveryCourierId,
    } || {};

    const city = JSON.parse(this.seller.city);
    const district = JSON.parse(this.seller.district);
    const town = JSON.parse(this.seller.town);

    const formData = {
      categoryId: this.secondTab.categoryId,
      productId: this.secondTab.productId,
      isCashback: this.secondTab.isCashback,
      answers: this.secondTab.answers,
      seller: {
        ...this.seller,
        cityId: city.id.toString(),
        districtId: district.id.toString(),
        townId: town.id.toString(),
      },
      ...(isHomeDelivery && homeDeliveryProps),
    };
    delete formData.seller.city;
    delete formData.seller.district;
    delete formData.seller.town;

    return formData;
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/shared/form-data.service.ts